import React, { Fragment, useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

const Voucher = (props) => {
  const [grid, setGrid] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const editRecord = (val) => {
    var temp = window.btoa(val);
    props.history.push("/branch/voucher/add?id=" + temp);
  };

  const [gridParam, setGridParam] = useState({});
  const columns = [
    {
      key: "voucher_name",
      text: "Voucher Name",
      align: "left",
      sortable: true,
    },
    {
      key: "voucher_heading",
      text: "Voucher Heading",
      align: "left",
      sortable: true,
    },
    {
      key: "voucher_value",
      text: "value",
      align: "left",
      sortable: true,
    },
    {
      key: "start_date",
      text: "Start Date",
      align: "left",
      sortable: true,
    },
    {
      key: "end_date",
      text: "End Date",
      align: "left",
      sortable: true,
    },
    {
      key: "Expire",
      text: "Expire",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <span>
              {record.voucher_expire === "true" ? (
                <label className="text-danger">Disabled</label>
              ) : (
                <label className="text-success">Active</label>
              )}
            </span>
          </Fragment>
        );
      },
    },
    {
      key: "disable",
      text: "Status",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <Fragment>
            <span>
              {record.disable === true ? (
                <label className="text-danger">Disabled</label>
              ) : (
                <label className="text-success">Active</label>
              )}
            </span>
          </Fragment>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => editRecord(record.voucher_id)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit"></i>
            </button>
          </Fragment>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/masters/customer/voucher/browse", gridParam).then((data) => {   
      setGrid(data.data);
      setLoad(false);
    });
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">Customer Voucher</h3>
          </div>
          <div className="card-toolbar">
            <a
              href="/branch/voucher/add"
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3"
            >
              <i className="flaticon2-user"></i> Add Voucher
            </a>
          </div>
        </div>
        <div className="card-body">
          <ReactDatatable config={config} records={grid} columns={columns} />
        </div>
      </div>
    </>
  );
};

export default Voucher;
